import { Injectable } from '@angular/core';
import {PagedResponseYearlyProductFacts} from '../models/YearlyProductFacts'
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {YearsWithCapacity} from '../models/YearsWithCapacity';

@Injectable({
  providedIn: 'root'
})

export class YearlyProductFactsService 
{
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }

  getYearlyProductFacts(id: number, startDate:string, labourClass:string, glAccountImpactingArea:number, shopId:number, companyId:number): Observable<PagedResponseYearlyProductFacts> 
  {
        const company =this.http.get<PagedResponseYearlyProductFacts>(this.APIURL+ "/YearlyProductFact?ID=" + id + "&startDate=" + startDate + "&labourClass=" + labourClass+ "&glAccountImpactingArea=" + glAccountImpactingArea +"&shopId="+ shopId +"&companyId="+ companyId);

        console.log('parameterss ID +' + id + "&startDate=" + startDate + "&labourClass=" + labourClass+ "&glAccountImpactingArea=" + glAccountImpactingArea +"&shopId="+ shopId);

    this.messageService.add(`YearlyProductFacts Service: fetched YearlyProductFacts with id=${id}`);
    return company;
  }

  getYearsWithCapacity(companyId:number):Observable<YearsWithCapacity[]>
  {
    const yearsWithCapacity = this.http.get<YearsWithCapacity[]>(this.APIURL+'/YearlyProductFact/GetYearsWithCapacityByCompanyID/' + companyId);
    return yearsWithCapacity;
  }


}